enum LAYOUT_MODE {
  LIGHT = "light",
  DARK = "dark",
}

enum SIDEBAR_COLOR {
  LIGHT = "light",
  DARK = "dark",
  BRAND = "brand",
}

enum LAYOUT_DIRECTION {
  LTR = "ltr",
  RTL = "rtl",
}

enum LAYOUT_TYPE {
  LG = "lg",
  SM = "sm",
}

enum LAYOUT_TYPE_NAME {
  VERTICAL = "vertical",
  CREATIVEDETACHED = "creative-detached",
  SIMPLEDETACHED = "detached-simple",
}

export {
    LAYOUT_MODE,
    LAYOUT_DIRECTION,
    LAYOUT_TYPE,
    LAYOUT_TYPE_NAME,
    SIDEBAR_COLOR
}